'use client';

import cn from 'classnames';

import createStyles from '@guestyci/foundation/createStyles';

import requiredIconMap from 'assets/icons/iconMap';


const useStyles = createStyles(() => ({
  root: {
    height: '1em',
    width: '1em',
    fontSize: ({ fontSize }) => fontSize,
  },
}));

const Icon = ({ icon, className, size, onClick }) => {
  const { root } = useStyles({ fontSize: size });
  const IconComponent = requiredIconMap[icon];

  if (!IconComponent) return null;
  return <IconComponent className={cn(root, className)} onClick={onClick} />;
};

export default Icon;
